import { render, staticRenderFns } from "./pjBiddingFile.vue?vue&type=template&id=ef6e3146&scoped=true"
import script from "./pjBiddingFile.vue?vue&type=script&lang=js"
export * from "./pjBiddingFile.vue?vue&type=script&lang=js"
import style0 from "./pjBiddingFile.vue?vue&type=style&index=0&id=ef6e3146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6e3146",
  null
  
)

export default component.exports